export const checkCookie = (name: string, value: string = 'true') => document.cookie.indexOf(`${name}=${value}`) !== -1

export interface Cookie {
    name: string;
    value: string;
}

export const getCookies = (): Cookie[] => {
	return document.cookie.split('; ').map((cookieString) => {
		const cookie = cookieString.split('=')
		return {
			name: cookie[0],
			value: cookie[1],
		}
	})
}

export const getCookie = (name: string): Cookie | null | undefined => {
	const cookies = getCookies()
	return cookies.find((item) => item?.name === name)
}

export const expireCookie = (name: string) => document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
